module.exports = __webpack_public_path__ + "components/country-flag/static/uy-e98715aaccdc153bf31310004ef33b53.svg";